import { useWebsiteSettings } from 'client/store'
import React from 'react'
import { getCurrentWebsiteTheme } from 'src/editor/store/website-settings/website-settings-selector'
import { useTypedTranslation } from 'src/shared/i18next/hooks/use-typed-translation'
import { EmptyWebsiteIcon } from 'src/shared/icons/empty-website-icon'
import { twMerge } from 'tailwind-merge'

export const EmptyWebsiteBody = () => {
  const { t } = useTypedTranslation()

  const theme = useWebsiteSettings(getCurrentWebsiteTheme)
  const isBgPictureSet = !!theme?.background.pageBackgroundPicture.file

  return (
    <div className="flex h-[600px] flex-col items-center justify-center">
      <div
        className={twMerge(
          'relative rounded-2xl px-4 py-8',
          !isBgPictureSet && 'bg-black/12',
        )}
      >
        {isBgPictureSet && (
          <div className="absolute top-0 right-0 bottom-0 left-0 -z-10 rounded-2xl bg-white/5 backdrop-blur-lg" />
        )}
        <EmptyWebsiteIcon
          className="z-10"
          bordersColor="#00000033"
          mainColor={isBgPictureSet ? '#FFFFFF' : '#000000'}
        />
      </div>
      <div className="flex max-w-[300px] flex-col items-center justify-center">
        <h3
          style={{ color: theme?.text.headingTextColor }}
          className="text-heading-3 text-inherit"
        >
          {t('entities.website_body.empty.title')}
        </h3>
        <p
          style={{ color: theme?.text.paragraphTextColor }}
          className="text-center text-M text-inherit"
        >
          {t('entities.website_body.empty.description')}
        </p>
      </div>
    </div>
  )
}
